"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBankByBestOffers = void 0;
var sortBankByBestOffers = function (banksList) {
    return banksList
        .map(function (bank) {
        bank.programs.sort(function (a, b) { return a.interest_rate - b.interest_rate; });
        return bank;
    })
        .sort(function (a, b) {
        var ABankTotalInterest = a.programs.reduce(function (acc, program) { return acc + program.interest_rate; }, 0);
        var BBankTotalInterest = b.programs.reduce(function (acc, program) { return acc + program.interest_rate; }, 0);
        return ABankTotalInterest - BBankTotalInterest;
    });
};
exports.sortBankByBestOffers = sortBankByBestOffers;
